import { render } from "./Start.vue?vue&type=template&id=169739ab&scoped=true&ts=true"
import script from "./Start.vue?vue&type=script&lang=ts"
export * from "./Start.vue?vue&type=script&lang=ts"

import "./Start.vue?vue&type=style&index=0&id=169739ab&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-169739ab"],['__file',"src/views/start/Start.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "169739ab"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('169739ab', __exports__)) {
    api.reload('169739ab', __exports__)
  }
  
  module.hot.accept("./Start.vue?vue&type=template&id=169739ab&scoped=true&ts=true", () => {
    api.rerender('169739ab', render)
  })

}


export default __exports__